module.exports = __webpack_public_path__ + "img/en.d1575226.svg";